module.exports = __webpack_public_path__ + "static/media/db.6d8dafec.png";